<template lang="">
    <div>
        <cart-quantity-selector :storage="cartItem.storage" v-model="cartData.quantity" @input="update">
        </cart-quantity-selector>
    </div>
</template>
<script>
    import axios from 'axios';
    import eventHub from '../../../library/event-hub';

    export default {
        props: {
            cartItem: {
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                productId: undefined,
                cartData: {
                    storage: undefined,
                    quantity: undefined
                }
            };
        },
        mounted() {
            this.syncData(this.cartItem);
        },
        watch: {
            cartItem: {
                deep: true,
                handler(newValue, oldValue) {
                    this.syncData(newValue);
                }
            }
        },
        methods: {
            syncData(newData) {
                this.productId = newData.product_id;
                this.cartData.storage = newData.storage_id;
                this.cartData.quantity = newData.quantity;
            },
            update() {
                let api_url = `${base_url}/api/carts/update/${this.productId}`;
                axios.patch(api_url, this.cartData)
                    .then(success_response => {
                        // console.log(success_response)
                        eventHub.$emit('cart-updated', success_response.data);
                        let myData = success_response.data.filter(item => {
                            // console.log(item);
                            return this.productId === item.product_id &&
                                this.cartData.storage === item.storage_id;
                        });
                        if (myData.length) this.syncData(myData[0]);
                        // this.;
                    })
                    .catch(error => {
                        let error_response;
                        if (!error.isAxiosError) console.log('error', [error]);
                        else {
                            error_response = error.response;
                            console.log(error_response);
                        }
                    });
            }
        }
    }
</script>
<style lang="">

</style>